<p-table #pt [value]="developments" [paginator]="true" [rows]="25" [rowsPerPageOptions]="[25,100,200]" [lazy]="true" (onLazyLoad)="loadLazy($event)" [totalRecords]="recordTotal" [responsive]="true" sortMode="multiple"
	selectionMode="single" [(selection)]="development" dataKey="developmentId" (onRowSelect)="onRowSelect($event)" [loading]="loading" styleClass="p-datatable-striped">
	<ng-template pTemplate="caption">
		<div class="d-block text-end justify-content-between align-items-center">
			<h1 style="float: left;margin: 6px;">Developments</h1>
			<span>
				<!--clear filters-->
				<button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
                (click)="openPublicTaskList()">Tasks</button>
        <button pButton pRipple class="p-button-text"
					style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
					(click)="reloadPage()">Clear Filters</button>

				<!--add new-->
				<button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
					routerLink="/development-add">New Development +</button>

			</span>
		</div>
	</ng-template>
	<ng-template pTemplate="header">
		<tr>
			<th [pSortableColumn]="'developmentId'">
				<p-sortIcon [field]="'developmentId'"></p-sortIcon>DevelopmentId
			</th>
			<th [pSortableColumn]="'listingStatus'">
				<p-sortIcon [field]="'listingStatus'"></p-sortIcon>Status
			</th>
			<th [pSortableColumn]="'addressDevelopmentName'">
				<p-sortIcon [field]="'adrDevelopmentName'"></p-sortIcon>Name
			</th>
			<th [pSortableColumn]="'addressCity'">
				<p-sortIcon [field]="'adrCity'"></p-sortIcon>City
			</th>
			<th [pSortableColumn]="'addressDistrict'">
				<p-sortIcon [field]="'adrDistrict'"></p-sortIcon>District
			</th>
			<th [pSortableColumn]="'addressState'">
				<p-sortIcon [field]="'adrState'">State</p-sortIcon>
			</th>
		</tr>
		<tr>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="number" (input)="pt.filter($event.target.value, 'developmentId', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}">
				<p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [(ngModel)]="listingStatusObj" [options]="listingStatuses" appendTo="body"
					(onChange)="pt.filter($event.value, 'listingStatus', 'in')" styleClass="p-column-filter"
					placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
					<ng-template let-option pTemplate="item">
						<span>{{option.name}}</span>
					</ng-template>
				</p-dropdown>
			</th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addressDevelopmentName', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addressCity', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addressDistrict', 'in')"></th>
			<th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addressState', 'in')"></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-development>
		<tr [pSelectableRow]="development">
			<td>{{development.developmentId}}</td>
			<td>{{ListingStatus[development['listingStatus']] }}</td>
			<td>{{development.adrDevelopmentName}}</td>
			<td>{{development.adrCity}}</td>
			<td>{{development.adrDistrict}}</td>
			<td>{{development.adrState}}</td>
		</tr>
	</ng-template>

	<ng-template pTemplate="paginatorCenter"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template>
</p-table>
